export const socialsData = {
    github: 'https://github.com/amar969',
    linkedIn: 'https://www.linkedin.com/in/amarjeet-maurya-41ab50137/',
    codepen: 'https://codepen.io/amarrjeet',
    blogger: 'https://www.blogger.com/profile/17732195566605127841',
}